import BaseObject from '../../../base/base_object';
import GamesJackpotsPublisher from './games_jackpots_publisher';
import JackpotFeedsReader from './jackpot_feeds_reader';
import {TimeSpan} from "@sparkware/app-utils";
import ServiceFactory from '../../service_factory';

export default class JackpotFeedsServiceDependenciesFactory extends BaseObject {
    static CLASS = 'JackpotFeedsServiceDependenciesFactory';
    _serviceFactory: ServiceFactory;
    _getJackpotsUrl: string;
    _getGameJackpotUrl: string;
    _jackpotsRefreshInterval: TimeSpan;

    init(params) {
        super.init(params);

        if(!params.serviceFactory) {
            this.throwArgumentExpected('18', 'init', 'serviceFactory');
        }

        if(!params.getJackpotsUrl) {
            this.throwArgumentExpected('22', 'init', 'getJackpotsUrl');
        }

        if(!params.getGameJackpotUrl) {
            this.throwArgumentExpected('26', 'init', 'getGameJackpotUrl');
        }

        if(!params.jackpotsRefreshInterval) {
            this.throwArgumentExpected('30', 'init', 'jackpotsRefreshInterval');
        }

        this._serviceFactory = params.serviceFactory;
        this._getJackpotsUrl = params.getJackpotsUrl;
        this._getGameJackpotUrl = params.getGameJackpotUrl;
        this._jackpotsRefreshInterval = params.jackpotsRefreshInterval;

    }

    createFeedsObservable(milliseconds) {
        return this._serviceFactory.observableFactoryService().fromInterval(milliseconds, 'JACKPOT_FEEDS_REFRESH_INTERVAL');
    }

    createGamesJackpotsPublisher(): GamesJackpotsPublisher {
        return GamesJackpotsPublisher.create({
            serviceFactory: this._serviceFactory,
            //we use only 90% of the refresh interval so the publisher finish the publishing before next refresh occurs
            refreshInterval: TimeSpan.fromMilliseconds(this._jackpotsRefreshInterval.totalMilliseconds * 0.9)
        });
    }

    createJackpotFeedsReader(): JackpotFeedsReader {
        return JackpotFeedsReader.create({
            serviceFactory: this._serviceFactory,
            getJackpotsUrl: this._getJackpotsUrl,
            getGameJackpotUrl: this._getGameJackpotUrl
        });
    }
}
